import { formatMoney } from './format.js';

export function CostBreakdown({ rows, total, totalLabel = 'Total' }) {
  return (
    <table className="cost-table">
      <tbody>
        {rows.map((r, i) => (
          <tr
            key={i}
            className={r.tone ? `cost-row cost-row-${r.tone}` : 'cost-row'}
          >
            <th scope="row">
              {r.label}
              {r.note ? <span className="cost-note"> {r.note}</span> : null}
            </th>
            <td>{formatMoney(r.amount, { sign: r.sign })}</td>
          </tr>
        ))}
      </tbody>
      {total !== undefined ? (
        <tfoot>
          <tr className="cost-row cost-row-total">
            <th scope="row">{totalLabel}</th>
            <td>{formatMoney(total)}</td>
          </tr>
        </tfoot>
      ) : null}
    </table>
  );
}
